import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { brandPropTypes, quotationItemShape } from "app/utils/propTypes";
import QuotationItem from "app/pages/Booking/Quotation/PriceDetails/QuotationItem";
import { BRANDS, QUOTATION_ITEMS_TYPE } from "app/constants";
import { calculateFlexExtra } from "app/pages/Booking/bookingSelectors";

class QuotationItemsContainer extends Component {
	render() {
		const { quotationItems, brand, flexExtra } = this.props;

		return (
			<React.Fragment>
				{quotationItems.map((quotationItem, index) => {
					const isBasePrice = index === 0;
					const hideQuotationItem =
						quotationItem.type === QUOTATION_ITEMS_TYPE.BOOKING_FEES &&
						brand === BRANDS.AX;
					return (
						!hideQuotationItem && (
							<QuotationItem
								key={quotationItem.description}
								description={quotationItem.description}
								price={
									isBasePrice
										? quotationItem.price + flexExtra
										: quotationItem.price
								}
								isBasePrice={isBasePrice}
							/>
						)
					);
				})}
			</React.Fragment>
		);
	}
}

QuotationItemsContainer.propTypes = {
	brand: brandPropTypes,
	quotationItems: PropTypes.arrayOf(quotationItemShape),
	flexExtra: PropTypes.number,
};

QuotationItemsContainer.defaultProps = {
	quotationItems: [],
	flexExtra: 0,
};

const mapStateToProps = state => {
	return {
		brand: state.brand.code,
		quotationItems: state.quotation.quotationItems,
		flexExtra: calculateFlexExtra(state),
	};
};

export default connect(mapStateToProps)(QuotationItemsContainer);
